// jshint asi: true
// jshint devel: true
// jshint unused:false

var form = $('.form_JS')

function validEmail(v) {
	var r = new RegExp("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?")
	return (v.match(r) === null) ? false : true
}

function validateForm() {
	
	/* Validate Text Inputs */
	form.find('input[type="text"][require]').each(function() {
		if ($(this).val().length < 4) {
			$(this).parent().addClass('error')
		} else {
			$(this).parent().removeClass('error')
		}
	})
	
	/* Validate Email Inputs */
	form.find('input[type="email"][require]').each(function() {
		if (!validEmail($(this).val())) {
			$(this).parent().addClass('error')
		} else {
			$(this).parent().removeClass('error')
		}
	})
	
	/* Validate Textareas */
	form.find('textarea[require]').each(function() {
		if ($(this).val().length < 8) {
			$(this).parent().addClass('error')
		} else {
			$(this).parent().removeClass('error')
		}
	})
	
	/* Submit */
	if (!$('.form_JS .error').length) {
		form[0].submit()
		form.find('.form--error').removeClass('error')
	} else {
		form.find('.form--error').addClass('error')
		return
	}

}

form.submit(function(e) {
	e.preventDefault()
	validateForm()
})

$('textarea').on('change keydown paste input',function () {
	if ($(this).val() !== '') {
		$(this).addClass('active')
	} else {
		$(this).removeClass('active')
	}
})